exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,300,500);", ""]);

// module
exports.push([module.id, "body{font-family:Roboto,sans-serif;background-color:#eee}.nav-link{text-decoration:none}.page-content{padding:20px 40px}.page-title{max-width:1200px;margin:20px auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader!./~/sass-loader?outputStyle=expanded!./src/styles/App.scss
 ** module id = 223
 ** module chunks = 0
 **/